import React from "react";

import { TextField as TextFieldMui } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import { isAddressEqual } from "../../utils/utils";

const getAddressLabel = (option) =>
  `${option.name}, ${option.street}, ${option.city}, ${option.state} ${option.zipCode}, ${option.country}`;

// Shared "Address Book" selector used by the manager Outbound forms
// (AddressBookSelect) and the carrier/customer Advice forms (getAddressBook).
// getOptionSelected matches on id when present and otherwise on address
// equality, so a stripped value (id removed by handleShipToSelect) still
// resolves to its full-record option instead of triggering MUI's
// "none of the options match" warning.
export const AddressAutocomplete = ({ options, value, onChange }) => (
  <Autocomplete
    options={options}
    getOptionLabel={getAddressLabel}
    getOptionSelected={(option, selected) =>
      (selected?.id && option.id === selected.id) ||
      isAddressEqual(option, selected)
    }
    value={value}
    onChange={onChange}
    renderInput={(params) => (
      <TextFieldMui
        {...params}
        label="Address Book"
        margin="dense"
        variant="outlined"
        fullWidth
        helperText={false}
        inputProps={{
          ...params.inputProps,
          autoComplete: "new-password",
          "data-lpignore": "true",
          "data-form-type": "other",
        }}
      />
    )}
  />
);
